export const defaultMenuConfig = [
  "tenants",
  "people",
  "endpoints",
  "integrations",
  "network",
  "vulnerability-scan",
  "virtual-machine",
  "mobile"
];

export const wgMenuConfig = ["tenant-settings", "endpoints", "integrations",];

export const wgParentMenuConfig = ["tenant-settings", "tenants"]
